export default {
    notificationData: {
        show: false,
        message: '',
        type: ''
    },
    confirm: {
        show: false,
        message: '',
        title: '',
        callback: null
    },
    confirmConflict: {
        show: false,
        callback: null,
        data: {}
    },
    confirmNotification: {
        show: false,
        message: '',
        title: ''
    },
    loading: {
        count: 0
    },
    currentMenu: null,
    currentPath: null,
    currentPathName: null,
    currentFullPath: null,
    isShowMenuLeft: false,
    alertList: [],
    request: {
        patternList: [],
        patternId: null,
        approveUserList: [],
        watchUserList: [],
        userList: [],
        selectList: [],
        note: '',
        offsetTop: 0,
        dataRequestMaterialList: []
    },
    selectId: 0
};
